// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { ChevronDown, ChevronUp, ChevronsUpDown } from "lucide-react";

/**
 * Clickable, sortable <th> for the hand-rolled admin list tables. Drives, and
 * reflects, the state from `useSortableData`.
 */
const SortableHeader = ({
  label,
  sortKey,
  sortConfig,
  onSort,
  align = "left",
  className = "",
}) => {
  const active = sortConfig?.key === sortKey;
  const direction = active ? sortConfig.direction : null;
  const alignClass = align === "right" ? "text-right" : "text-left";

  const Icon = !active
    ? ChevronsUpDown
    : direction === "asc"
      ? ChevronUp
      : ChevronDown;

  return (
    <th
      className={`${alignClass} text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-wider px-4 py-3 ${className}`}
    >
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={`group inline-flex items-center gap-1 uppercase tracking-wider hover:text-gray-700 dark:hover:text-slate-200 transition-colors ${
          align === "right" ? "flex-row-reverse" : ""
        }`}
        title={`Nach ${label} sortieren`}
      >
        <span>{label}</span>
        <Icon
          className={`w-3.5 h-3.5 shrink-0 transition-opacity ${
            active
              ? "primary-color"
              : "text-gray-400 dark:text-slate-500 opacity-0 group-hover:opacity-100"
          }`}
        />
      </button>
    </th>
  );
};

export default SortableHeader;
